import React, { useState } from 'react';
import { useToast } from '../hooks/use-toast';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: 'Email required',
        description: 'Please enter your email address',
        variant: 'destructive',
      });
      return;
    }

    setIsSubmitting(true);
    
    // Simulate API call (will be replaced with actual backend call)
    setTimeout(() => {
      toast({
        title: 'Welcome to Guriva!',
        description: 'Thank you for subscribing to our newsletter',
      });
      setEmail('');
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <section className="py-20 bg-amber-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-serif text-neutral-800 mb-4 tracking-wide">
          Join Our World
        </h2>
        <p className="text-neutral-700 mb-8">
          Unique Gifts Update And Guriva Happenings Straight to Your Inbox.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 px-6 py-3 border border-neutral-300 focus:outline-none focus:border-neutral-500 transition-colors"
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-8 py-3 bg-amber-700 text-white tracking-widest uppercase hover:bg-amber-800 transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default NewsletterSection;